import React from 'react';
import Layout from '../../../components/layout/Layout';
import AdminLenders from '../../../components/lender/Lenders';
import AnalyticsWrapper from '../../../components/common/AnalyticsWrapper';

const LendersView = () => {
  return (
    <AnalyticsWrapper>
      <Layout title="Lenders">
        <AdminLenders />
      </Layout>
    </AnalyticsWrapper>
  );
};

export default LendersView;
